<Modal title="Confirm request" actionTitle="Confirm" {isLoading} on:close={() => $uiState.activeModal = undefined} on:action={() => apply()}>
  <p class="block">
    Your contact details will be shared with the business.
  </p>
  <p class="block">
    We'll then leave it to you to arrange collection/delivery.
  </p>
</Modal>

<script lang="ts">

  export let offerId : string, requestId : string;

  import { uiState } from '../../../../lib/uiState';
  import Modal from 'components/Modal.svelte';

  let isLoading = false;


  async function apply() {

    isLoading = true;

    let firebase = window.firebase;

    await firebase.functions().httpsCallable('api-request-confirmrequest')({offerId, requestId} as ConfirmRequestParams);

    isLoading = false;

    $uiState.activeModal = undefined;
  }

</script>